export default "__VITE_ASSET__FP1q1UDH__"